import { store } from '@store';
import { ConfigurationApi } from '@api/ConfigurationApi';
import { AnyObject } from '@store/types';

class AppService {
    private serviceConfigLoaded = false;

    public async loadSipConfig(): Promise<void> {
        const { app } = store;
        if (!app.sipConfigLoaded) {
            app.sip = await ConfigurationApi.getSipConfig();
        }
    }

    public async loadServicesConfig(): Promise<void> {
        const { app } = store;
        if (!this.serviceConfigLoaded) {
            this.serviceConfigLoaded = true;
            const config: AnyObject = await ConfigurationApi.getServicesConfig();
            Object.keys(config).forEach(configName => {
                (app as AnyObject)[configName] = config[configName];
            });
        }
    }

    public async loadSupportConfig(): Promise<void> {
        const { isEnabled } = await ConfigurationApi.getSupportConfig();
        store.app.isSupportEnabled = isEnabled;
    }
}

export const appService = new AppService();
